import { useState } from "react";
import { Plus, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { textOn } from "@/lib/jobTypes";

const Group = ({ label, group, items, all, onChange, inputId }) => {
  const [value, setValue] = useState("");
  const add = () => {
    const v = value.trim();
    if (!v || all.some((t) => t.name.toLowerCase() === v.toLowerCase())) return;
    onChange([...all, { name: v, color: "#64748B", group }]);
    setValue("");
  };
  const update = (name, patch) => onChange(all.map((t) => (t.name === name ? { ...t, ...patch } : t)));
  return (
    <div>
      <h4 className="mb-2 text-[11px] font-semibold uppercase tracking-wider text-slate-500">{label}</h4>
      <ul className="space-y-1.5">
        {items.map((t) => (
          <li key={t.name} className="flex items-center gap-2 rounded-md border border-slate-200 bg-slate-50 p-1.5" data-testid={`job-type-row-${t.name}`}>
            <input type="color" value={t.color} onChange={(e) => update(t.name, { color: e.target.value.toUpperCase() })} data-testid={`job-type-color-${t.name}`} className="h-8 w-10 cursor-pointer rounded border-0 bg-transparent p-0" title="Change colour" />
            <span className="flex-1 rounded px-2 py-1 text-sm font-semibold" style={{ background: t.color, color: textOn(t.color) }}>{t.name}</span>
            <span className="font-mono text-[11px] text-slate-400">{t.color}</span>
            <button onClick={() => onChange(all.filter((x) => x.name !== t.name))} className="rounded p-1 text-slate-400 hover:bg-rose-50 hover:text-rose-600" data-testid={`job-type-remove-${t.name}`}><X className="h-3.5 w-3.5" /></button>
          </li>
        ))}
      </ul>
      <div className="mt-2 flex gap-2">
        <Input value={value} onChange={(e) => setValue(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} placeholder={`Add ${label.toLowerCase()} route…`} className="h-9" data-testid={inputId} />
        <Button size="sm" variant="outline" onClick={add} data-testid={`${inputId}-add`}><Plus className="h-4 w-4" /> Add</Button>
      </div>
    </div>
  );
};

export const JobTypeEditor = ({ items, onChange }) => (
  <div className="rounded-xl border border-slate-200 bg-white p-5" data-testid="job-type-editor">
    <h3 className="font-display text-base font-semibold text-[#0E1E38]">Job types / routes & calendar colours</h3>
    <p className="mt-0.5 text-xs text-slate-500">Each route gets its own colour on the calendar. Click a swatch to change it.</p>
    <div className="mt-4 grid gap-6 md:grid-cols-2">
      <Group label="Interstate / Share Load" group="interstate" items={items.filter((t) => t.group === "interstate")} all={items} onChange={onChange} inputId="job-type-input-interstate" />
      <Group label="Local" group="local" items={items.filter((t) => t.group !== "interstate")} all={items} onChange={onChange} inputId="job-type-input-local" />
    </div>
  </div>
);
